import { render } from "./ConfigurationIndex.vue?vue&type=template&id=0d1f7a26&scoped=true"
import script from "./ConfigurationIndex.vue?vue&type=script&lang=js"
export * from "./ConfigurationIndex.vue?vue&type=script&lang=js"

import "./ConfigurationIndex.vue?vue&type=style&index=0&id=0d1f7a26&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d1f7a26"]])

export default __exports__